module.exports = __webpack_public_path__ + "static/media/part-detail-slide-2.57450859.jpg";